<style scoped>

</style>
<template>
  <span>{{ name }}</span>
</template>
<script>
  import {mapGetters} from "vuex";

  export default {
    props: {
      id: {
        type: [Number],
        // required: true
      },
      short: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters('async', ['companies_hash']),
      name() {
        if (!this.id) return '未设置';
        const company = this.companies_hash[this.id];
        const not_found = '未找到';
        if (this.short) {
          return company ? company.short_name : not_found
        }
        return company ? company.name : not_found;
      }
    },
  }
</script>
